<template>
  <div class="modal modal-previous-commissions" :class="{ 'show': showModal }">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Previous Commissions</h5>
          <button type="button" class="close" @click="showModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="accordion" id="prev-commissions">
            <div v-for="(commission, index) in commissions" :key="index" class="card card-previous-commissions">
              <div class="card-header" :id="`commissions-header-${index}`">
                <a href="#" class="btn btn-header-link py-0" @click.prevent="toggleCollapse(`period-${index}`)">
                  {{ formattedPeriod(commission.period) }}
                  <span class="badge badge-primary">
                    Total {{ getTotalStudents(commission.data) }} Students
                  </span>
                  <span class="badge badge-primary">
                    Total Earnings ${{ getTotalEarnings(commission.data, commission.transactions) }}
                  </span>
                </a>
              </div>
              <div :class="getCollapseClass(`period-${index}`)" :id="`period-${index}`" data-parent="#prev-commissions">
                <div class="card-body">
                  <div v-if="commission.data.length > 0" class="accordion" id="data">
                    <div class="card card-previous-commission-data">
                      <div class="card-header" :id="`data-header-${index}`">
                        <a href="#" class="btn btn-header-link py-0" @click.prevent="toggleCollapse(`data-${index}`)">
                          Commissions
                        </a>
                      </div>
                      <div :class="getCollapseClass(`data-${index}`)" :id="`data-${index}`" data-parent="#data">
                        <div class="card-body card-commission-data">
                          <previous-commission-data :commission-data="commission.data" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="commission.transactions.length > 0" class="accordion" id="transactions">
                    <div class="card card-previous-commission-transactions">
                      <div class="card-header" :id="`transactions-header-${index}`">
                        <a href="#" class="btn btn-header-link py-0" @click.prevent="toggleCollapse(`transactions-${index}`)">
                          Additional Commissions
                        </a>
                      </div>
                      <div :class="getCollapseClass(`transactions-${index}`)" :id="`transactions-${index}`" data-parent="#transactions">
                        <div class="card-body card-commission-transactions">
                          <previous-commission-transactions :commission-transactions="commission.transactions" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatPeriod} from "../../../utils/helpers";
import PreviousCommissionData from "./PreviousCommissionData.vue";
import PreviousCommissionTransactions from "./PreviousCommissionTransactions.vue";

import '../../../../sass/commissions/previous-commissions.scss';

export default {
  name: 'PreviousCommissionsModal',
  components: {
    PreviousCommissionData,
    PreviousCommissionTransactions
  },
  data() {
    return {
      showModal: false,
      commissions: [],
      transactions: [],
      collapsedItems: {},
    };
  },
  mounted() {
    this.getPreviousTransactions();
  },
  methods: {
    toggleCollapse(id) {
      const element = document.getElementById(id);
      if (element) {
        const isCollapsed = element.classList.contains('show');
        if (isCollapsed) {
          $(element).collapse('hide');
        } else {
          $(element).collapse('show');
        }
      }
    },
    getCollapseClass(id) {
      return this.collapsedItems[id] ? 'collapse show' : 'collapse';
    },
    formattedPeriod(period) {
      return formatPeriod(period);
    },
    getPreviousTransactions() {
      this.transactions = this.commissions.reduce((acc, commission) => {
        acc[commission.period] = commission.data.map(item => item.transactions || []).flat();
        return acc;
      }, {});
    },
    getTotalStudents(data) {
      return new Set(data.map(item => item.student.id)).size;
    },
    getTotalEarnings(data, transactions) {
      return [...data, ...transactions].reduce((total, item) => total + parseFloat(item.total), 0).toFixed(2);
    }
  }
};
</script>